import React from 'react';
import get from 'lodash/get';

import API from '@utils/API';
import Condition from '@components/Conditions';
import { apiUrls } from '@constants/api';
import Helpers from '@utils/Helpers';
import { conditionsMeta } from '@constants/meta';

const ConditionPage = props => <Condition {...props} />;

ConditionPage.getInitialProps = async ctx => {
  const {
    query: { condition }
  } = ctx;
  try {
    const { data } = await API.get(apiUrls.conditions.details(condition));
    const conditionName = get(data, 'name');
    const conditionThumbnail = get(data, 'file');
    const conditionSlug = get(data, 'slug');

    const metaTitle = get(
      conditionsMeta,
      [conditionSlug, 'hub', 'title'],
      'CureRate'
    );
    const metaDescription = get(
      conditionsMeta,
      [conditionSlug, 'hub', 'description'],
      `Products, supplements, and recipes rated & reviewed by people with ${conditionName}.`
    );

    return {
      __meta__: {
        title: metaTitle,
        tags: {
          description: metaDescription,
          'og:title': metaTitle,
          'og:description': metaDescription,
          'og:image': conditionThumbnail
        }
      },
      condition: data
    };
  } catch (err) {
    Helpers.serverErrorHandler(err, ctx);
  }
};

export default ConditionPage;
